import { render, staticRenderFns } from "./SendSepaClaimResponseModal.vue?vue&type=template&id=56eb1900"
import script from "./SendSepaClaimResponseModal.vue?vue&type=script&lang=js"
export * from "./SendSepaClaimResponseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports